// models/faceRecognition.module.js
import * as faceapi from "face-api.js";

export const recognizeFace = async (videoElement) => {
  const detections = await faceapi
    .detectSingleFace(videoElement, new faceapi.TinyFaceDetectorOptions())
    .withFaceLandmarks()
    .withFaceDescriptor();

  if (!detections) return null;

  return detections.descriptor; // important!
};
